import { render, staticRenderFns } from "./leaddetails.vue?vue&type=template&id=c1b543fa&scoped=true&"
import script from "./leaddetails.vue?vue&type=script&lang=js&"
export * from "./leaddetails.vue?vue&type=script&lang=js&"
import style0 from "./leaddetails.vue?vue&type=style&index=0&id=c1b543fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b543fa",
  null
  
)

export default component.exports